import moment from 'moment';
import { apiGet, getHostApi, processErrorMessage } from './apiWrapper';
import { isNullOrUndefined } from './storeFunctions';
import { SECTIONS } from './reportStore';

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'; // hardcoded to save 9KB lib link just to get one value
const MONITORA_REQUEST = "MONITORA_REQUEST";
const MONITORA_SUCCESS = "MONITORA_SUCCESS";
const MONITORA_ERROR = "MONITORA_ERROR";
const MONITORA_EXPAND = "MONITORA_EXPAND";
const SECTION_PARAM_CHANGE = 'SECTION_PARAM_CHANGE';

const DETAIL_RETRIES = 10;

const REQUEST_TYPE = {
    annotations: "annotations",
    annotationsNextPage: "annotationsNextPage",
    detail: "detail"
};

const annotationsInitialState = {
    entityId: null,
    isLoading: false,
    isLoadingMore: false,
    annotations: [],
    nextPageToken: null,
    error: null
};

const detailInitialState = {
    entityId: null,
    articleId: null,
    articleToken: null,
    articleTitle: null,
    isLoading: false,
    isExpanded: false,
    paragraphs: null,
    error: null
};

const initialState = {
    annotations: { ...annotationsInitialState },
    details: {},
    settings: {
        dateFrom: null,
        dateTo: null
    }
};

export const monitoraActions = {
    getAnnotations: (entityId, dateFrom, dateTo) => async (dispatch, getState) => _getAnnotations(entityId, dateFrom, dateTo, dispatch, getState),
    getAnnotationsNextPage: (token) => async (dispatch, getState) => _getAnnotationsNextPage(token, dispatch, getState),
    getDetail: (articleId, articleToken, articleTitle, entityId) => async (dispatch, getState) => _getDetail(articleId, articleToken, articleTitle, entityId, dispatch, getState),
    expandDetail: (articleId, value) => async (dispatch, getState) => _expandDetail(articleId, value, dispatch, getState)
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case LOCATION_CHANGE:
            return { ...state, location: action.payload.pathname };
        case MONITORA_REQUEST:
            switch (action.monitoraType) {
                case REQUEST_TYPE.annotations:
                    return { ...initialState,
                        annotations: { ...annotationsInitialState, isLoading: true, entityId: action.entityId },
                        settings: { dateTo: action.dateTo, dateFrom: action.dateFrom }
                    };
                case REQUEST_TYPE.annotationsNextPage:
                    return { ...state, annotations: { ...state.annotations, isLoadingMore: true, nextPageToken: action.token } };
                case REQUEST_TYPE.detail:
                    const details = { ...state.details };
                    details[action.articleId] = { ...detailInitialState, isLoading: true, articleId: action.articleId, articleToken: action.articleToken,
                        articleTitle: action.articleTitle, entityId: action.entityId }
                    return { ...state, details: details };
                default:
                    return state;
            }
        case MONITORA_SUCCESS:
            switch (action.monitoraType) {
                case REQUEST_TYPE.annotations:
                    return { ...state,
                        annotations: { ...state.annotations, isLoading: false, annotations: action.data.annotations, nextPageToken: action.data.next_page, error: null }
                    };
                case REQUEST_TYPE.annotationsNextPage:
                    return { ...state,
                        annotations: { ...state.annotations, isLoadingMore: false, annotations: [...state.annotations.annotations, ...action.data.annotations],
                            nextPageToken: action.data.next_page, error: null }
                    };
                case REQUEST_TYPE.detail:
                    const details = { ...state.details };
                    details[action.articleId] = { ...state.details[action.articleId], isLoading: false, isExpanded: true, paragraphs: action.data.paragraphs, error: null };
                    return { ...state, details: details };
                default:
                    return state;
            }
        case MONITORA_ERROR:
            switch (action.monitoraType) {
                case REQUEST_TYPE.annotations:
                    return { ...state,
                        annotations: { ...state.detail, isLoading: false, annotations: [], nextPageToken: null, error: action.error } };
                case REQUEST_TYPE.annotationsNextPage:
                    return { ...state, annotations: { ...state.annotations, isLoadingMore: false, error: action.error } };
                case REQUEST_TYPE.detail:
                    const details = { ...state.details };
                    details[action.articleId] = { ...state.details[action.articleId], isLoading: false,  isExpanded: false, paragraphs: null, error: action.error };
                    return { ...state, details: details };
                default:
                    return state;
            }
        case MONITORA_EXPAND:
            switch (action.monitoraType) {
                case REQUEST_TYPE.detail:
                    const details = { ...state.details };
                    details[action.articleId] = { ...state.details[action.articleId], isExpanded: action.value };
                    return { ...state, details: details };
            }
        default:
            return state;
    };
};

function _getAnnotations(entityId, dateFrom, dateTo, dispatch, getState) {
    const queryParams = [];
    const dFrom = isNullOrUndefined(dateFrom) ? null : dateFrom;
    const dTo = isNullOrUndefined(dateTo) ? null : dateTo;

    if (dFrom !== null)
        queryParams.push(`dateFrom=${moment(dateFrom).format('YYYY-MM-DD')}`);
    if (dTo !== null)
        queryParams.push(`dateTo=${moment(dateTo).format('YYYY-MM-DD')}`);
    const query = queryParams.join("&");

    dispatch({ type: MONITORA_REQUEST, monitoraType: REQUEST_TYPE.annotations, entityId: entityId, dateTo: dTo, dateFrom: dFrom });
    apiGet(
        `${getHostApi()}/api/report/${entityId}/monitora-search${(query.length > 0 ? "?" + query : "")}`,
        {},
        (s) => { 
            if (s.error) {
                dispatch({ type: MONITORA_ERROR, monitoraType: REQUEST_TYPE.annotations, error: processErrorMessage({ data: s }, "Report.Monitora.UserNotConfiguredCorrectly") });
                _setSectionParams(dispatch, getState);
            } else {
                dispatch({ type: MONITORA_SUCCESS, monitoraType: REQUEST_TYPE.annotations, data: s.data });
                _setSectionParams(dispatch, getState);
            }
        },
        (e) => { 
            dispatch({ type: MONITORA_ERROR, monitoraType: REQUEST_TYPE.annotations, error: e });
            _setSectionParams(dispatch, getState);
        }
    )
}

function _getAnnotationsNextPage(token, dispatch, getState) {
    const state = getState();
    dispatch({ type: MONITORA_REQUEST, monitoraType: REQUEST_TYPE.annotationsNextPage, token: token });
    if (isNullOrUndefined(state.monitora.annotations) || isNullOrUndefined(state.monitora.annotations)) {
        dispatch({ type: MONITORA_ERROR, monitoraType: REQUEST_TYPE.annotationsNextPage, error: "Missing entity ID" });
        return;
    }

    apiGet(
        `${getHostApi()}/api/report/monitora-search/next/${token}`,
        {},
        (s) =>  {
            dispatch({ type: MONITORA_SUCCESS, monitoraType: REQUEST_TYPE.annotationsNextPage, data: s.data });
            _setSectionParams(dispatch, getState);
        },
        (e) => { 
            dispatch({ type: MONITORA_ERROR, monitoraType: REQUEST_TYPE.annotationsNextPage, error: e });
            _setSectionParams(dispatch, getState);
        }
    )
}

function _getDetail(articleId, articleToken, articleTitle, entityId, dispatch, getState) {
    dispatch({ type: MONITORA_REQUEST, monitoraType: REQUEST_TYPE.detail, articleId: articleId, articleToken: articleToken, articleTitle: articleTitle, entityId: entityId });
    apiGet(
        `${getHostApi()}/api/report/monitora-detail?articleId=${articleId}&articleToken=${articleToken}&entityId=${entityId}`,
        {},
        (s) => {
            if (s.hasData) {
                dispatch({ type: MONITORA_SUCCESS, monitoraType: REQUEST_TYPE.detail, articleId: articleId, data: s.data });
                _setSectionParams(dispatch, getState);
            }
            else {
                if (isNullOrUndefined(s.additionalData)) {
                    dispatch({ type: MONITORA_ERROR, monitoraType: REQUEST_TYPE.detail, error: 'Missing procesing ID' });
                    _setSectionParams(dispatch, getState);
                }
                else
                    _retryGetDetail(articleId, s.additionalData, DETAIL_RETRIES, dispatch, getState);
            }
        },
        (e) => {
            dispatch({ type: MONITORA_ERROR, monitoraType: REQUEST_TYPE.detail, articleId: articleId, error: e });
            _setSectionParams(dispatch, getState);
        }
    )
}

function _retryGetDetail(articleId, processingId, retriesLeft, dispatch, getState) {
    if (retriesLeft <= 0) {
        dispatch({ type: MONITORA_ERROR, monitoraType: REQUEST_TYPE.detail, articleId: articleId, error: 'Timed out' });
        return;
    }

    setTimeout(function() {
        apiGet(
            `${getHostApi()}/api/report/monitora-detail/${processingId}`,
            {},
            (s) => {
                if (s.hasData) {
                    dispatch({ type: MONITORA_SUCCESS, monitoraType: REQUEST_TYPE.detail, articleId: articleId, data: s.data });
                    _setSectionParams(dispatch, getState);
                }
                else {
                    if (isNullOrUndefined(s.additionalData)) {
                        dispatch({ type: MONITORA_ERROR, monitoraType: REQUEST_TYPE.detail, articleId: articleId, error: 'Missing procesing ID' });
                        _setSectionParams(dispatch, getState);
                    }
                    else
                        _retryGetDetail(articleId, s.additionalData, retriesLeft - 1, dispatch, getState);
                }
            },
            (e) => {
                dispatch({ type: MONITORA_ERROR, monitoraType: REQUEST_TYPE.detail, articleId: articleId, error: e });
                _setSectionParams(dispatch, getState);
            }
        );
    }, 2000);
}

function _expandDetail(articleId, value, dispatch, getState) {
    dispatch({ type: MONITORA_EXPAND, monitoraType: REQUEST_TYPE.detail, articleId, value });
    _setSectionParams(dispatch, getState);
}

function _setSectionParams(dispatch, getState) {
    const monitora = getState().monitora;
    const annotations = monitora.annotations;
    const details = monitora.details;

    let data = {
        settings: monitora.settings,
        annotationsCount: isNullOrUndefined(annotations) || isNullOrUndefined(annotations.annotations) ? 0 : annotations.annotations.length,
        details: isNullOrUndefined(annotations) || isNullOrUndefined(annotations.annotations) || isNullOrUndefined(details) ? [] :
            Object.assign({}, ...annotations.annotations.filter(x => !isNullOrUndefined(details[x.article_id]) && details[x.article_id].isExpanded)
                .map(x => ({ [x.article_id]: details[x.article_id].articleToken })))        
    };
    const newParams = { data: JSON.stringify(data) };
    dispatch({ type: SECTION_PARAM_CHANGE, sectionId: [SECTIONS.monitoraAnnotation], newParams });
}
